import React from "react";
import styled from "styled-components";
import BreadCrumb from "../../../BreadCrumb/BreadCrumb";
import StagnantTable from "./StagnantTable";

const StagnantProduct = () => {
  return (
    <StatgnantStyle>
      <BreadCrumb
        margin="mt-3"
        num1="واحد محتوا"
        num2="محصولات"
        num3="محصولات راکد"
        href1="/dashboard/content-controller"
        href2="/dashboard/content-controller/products"
      />
      <StagnantTable />
    </StatgnantStyle>
  );
};

const StatgnantStyle = styled.div``;

export default StagnantProduct;
